import React from 'react';
import { usePortal } from '../contexts/PortalContext';

/** Portal-staff only. Never rendered for a real client session. */
export function PreviewBanner() {
  const {
    endPreview,
    activeProject
  } = usePortal();
  return <div className="sticky top-0 z-40 border-b border-ruleDark bg-ink text-paper" data-id="element-407" data-mp="23rtuaiyz7hzv">
      <div className="mx-auto flex max-w-portal flex-wrap items-center justify-between gap-4 px-6 py-3 sm:px-10" data-id="element-408" data-mp="1ytsce1dadopz">
        <p className="label m-0 text-paper/70" data-id="element-409" data-mp="1b592jhel93vs">
          Preview Mode — Client View
          <span className="label-sm ml-4 text-paper/35" data-id="element-410" data-mp="173nldjv0u3fs">{activeProject.client}</span>
        </p>
        <button type="button" onClick={endPreview} className="label border border-paper/50 px-4 py-2.5 text-paper transition-colors duration-150 ease-out hover:bg-paper hover:text-ink" data-id="element-411" data-mp="1kuit2stsaehs">
          Return to Portal View
        </button>
      </div>
    </div>;
}